import { Unknown } from '../../constants/currency-codes';

export const calculateCustoms = (customs, needsCustoms, shouldCheckNeedsCustoms, latestNeedsCustomsCheck) => {
  const shouldNullifyCustoms = (shouldCheckNeedsCustoms && !latestNeedsCustomsCheck) || !needsCustoms;
  if (shouldNullifyCustoms) {
    return null;
  }
  return customs;
};

export const getCustomsItemsCurrencyCode = (customs, defaultCurrencyCode, isFeatureFlagEnabled) => {
  if (!isFeatureFlagEnabled) {
    return defaultCurrencyCode;
  }

  if (customs.dutiesPaid?.code === customs.postagePaid?.code && customs.dutiesPaid?.code !== Unknown) {
    return customs.dutiesPaid.code;
  }
  const firstItemCurrency = customs.customsItems?.[0]?.unitPrice?.code;
  if (firstItemCurrency) {
    return firstItemCurrency;
  }

  return defaultCurrencyCode;
};
